import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { DocumentTypeService } from '../document-type.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize, map, Observable } from 'rxjs';
import { IDocumentType, IEditDocumentTypePayload, IFormDocumentType } from '../document-type.interface';
import { Generic } from 'src/app/interfaces/generic.interface';
import { DocumentCategoryService } from '../../document-category/document-category.service';

@Component({
    selector: 'app-edit-document-type',
    templateUrl: './edit-document-type.component.html',
    styleUrls: ['./edit-document-type.component.scss']
})
export class EditDocumentTypeComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    documentCategories$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        slug: new FormControl(this.data.slug, [Validators.required]),
        categorie_id: new FormControl(this.data.categorie_id, [Validators.required, Validators.min(0)]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IDocumentType,
        private dialogRef: MatDialogRef<EditDocumentTypeComponent>,
        private documentTypeService: DocumentTypeService,
        private documentCategoryService: DocumentCategoryService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void {
        this.loadDocumentCategories()
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }


    loadDocumentCategories() {
        this.isLoading = true;
        this.documentCategories$ = this.documentCategoryService.listDocumentCategory().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    submitForm() {
        this.isLoading = true;

        const { name, categorie_id, slug } = this.form.value as IFormDocumentType;
        const payload: IEditDocumentTypePayload = {
            id: this.data.id,
            name,
            categorie_id,
            slug
        };

        this.documentTypeService
            .updateDocumentType(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
